/**
 * Returns mean value of number array
 * @param {number} numbers
 * @returns {number}
 */
export const mean = (...numbers: number[]): number => numbers.reduce((sum, number) => sum + number, 0) / numbers.length;

/**
 * Returns combined mean of two means
 * @param {CombinedMeanInput} meanA
 * @param {CombinedMeanInput} meanB
 * @returns {number}
 */
export const combinedMean = (meanA: CombinedMeanInput, meanB: CombinedMeanInput): number =>
	(meanA.mean * meanA.count + meanB.mean * meanB.count) / (meanA.count + meanB.count) || 0;
type CombinedMeanInput = { mean: number; count: number };

/**
 * Calculates percentage change (0-1) between two values
 * @param {number} v1
 * @param {number} v2
 * @return {number}
 */
export const percentageChange = (v1: number, v2: number): number => {
	if (v1 === 0 && v2 === 0) return 0;
	if (v1 === 0) return NaN;
	return (v2 - v1) / v1;
};

/**
 * Returns random number from an interval
 * @param {number} min
 * @param {number} max
 * @return {number}
 */
export const randomNumBetween = (min: number, max: number): number => {
	if (min === max) return min;
	if (min > max) [min, max] = [max, min];
	return Math.random() * (max - min) + min;
};

/**
 * Returns random integer from an interval
 * @param {number} min
 * @param {number} max
 * @return {number}
 */
export const randomIntBetween = (min: number, max: number): number => Math.floor(randomNumBetween(min, max));
